import { useEffect } from 'react';

/**
 * Custom hook for auto-scrolling to top when component mounts
 * @param {boolean} enabled - Whether to enable auto-scroll
 * @param {string} behavior - Scroll behavior ('smooth' or 'auto')
 */
export const useAutoScroll = (enabled = true, behavior = 'smooth') => {
    useEffect(() => {
        if (enabled) {
            window.scrollTo({ top: 0, behavior });
        }
    }, [enabled, behavior]);
};

/**
 * Custom hook for auto-scrolling to a specific element
 * @param {string} elementId - ID of the element to scroll to
 * @param {boolean} enabled - Whether to enable auto-scroll
 * @param {string} behavior - Scroll behavior ('smooth' or 'auto')
 * @param {number} offset - Offset from the top of the element
 */
export const useScrollToElement = (elementId, enabled = true, behavior = 'smooth', offset = 0) => {
    useEffect(() => {
        if (enabled && elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                const elementPosition = element.offsetTop - offset;
                window.scrollTo({ top: elementPosition, behavior });
            }
        }
    }, [elementId, enabled, behavior, offset]);
};

/**
 * Custom hook for auto-scrolling to a specific section
 * @param {string} sectionId - ID of the section to scroll to
 * @param {boolean} enabled - Whether to enable auto-scroll
 * @param {string} behavior - Scroll behavior ('smooth' or 'auto')
 */
export const useScrollToSection = (sectionId, enabled = true, behavior = 'smooth') => {
    useEffect(() => {
        if (enabled && sectionId) {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior, block: 'start' });
            }
        }
    }, [sectionId, enabled, behavior]);
};

export default useAutoScroll;
